import { useTranslation } from "react-i18next";
import style from "./style.module.scss";

const Sizes = ({ currentSize, sizes = [] }) => {
  // React i18next
  const { t } = useTranslation();

  let measures = [
    "mg",
    "g",
    "kg",
    "kgs",
    "cl",
    "ml",
    "l",
    "mm",
    "cm",
    "m",
    "inch",
    "in",
  ];

  sizes.sort(function (a, b) {
    let first = a.replaceAll(" ", "").toLowerCase();
    let second = b.replaceAll(" ", "").toLowerCase();
    let aMatch = first.match(/(\d+(?:\.\d+)?)([a-z]*)(.*?)$/);
    let bMatch = second.match(/(\d+(?:\.\d+)?)([a-z]*)(.*?)$/);
    if (aMatch && bMatch) {
      let aQty = parseFloat(aMatch[1]);
      let bQty = parseFloat(bMatch[1]);

      // Comparer les quantités
      if (aQty < bQty) {
        return -1;
      }
      if (aQty > bQty) {
        return 1;
      }
      if (aQty === bQty) {
        if (aMatch && bMatch) {
          return 0;
        }
        if (aMatch && !bMatch) {
          return -1;
        }
        if (!aMatch && bMatch) {
          return 1;
        }
      }
    }
    return 0;
  });

  sizes.sort(function (a, b) {
    let first = a.replaceAll(" ", "").toLowerCase();
    let second = b.replaceAll(" ", "").toLowerCase();
    let aMatch = first.match(/(\d+(?:\.\d+)?)([a-z]*)(.*?)$/);
    let bMatch = second.match(/(\d+(?:\.\d+)?)([a-z]*)(.*?)$/);
    if (aMatch && bMatch) {
      let aUnit = aMatch[2];
      let bUnit = bMatch[2];

      // Comparer les unités de mesure si les quantités sont égales
      if (measures.indexOf(aUnit) < measures.indexOf(bUnit)) {
        return -1;
      }
      if (measures.indexOf(aUnit) > measures.indexOf(bUnit)) {
        return 1;
      }
    }

    return 0;
  });

  return (
    <div className={style.block}>
      <div>{t("Available sizes")} :</div>

      {currentSize ? (
        <div className={style.sizes}>
          {sizes.length > 0 &&
            sizes.map((size) =>
              currentSize === size ? (
                <div key={size} className={style.currentSize}>
                  {size}
                </div>
              ) : (
                <a
                  key={size}
                  href={`?size=${size.replace(/[^0-9.]/g, "")}`}
                  className={style.size}
                >
                  {size}
                </a>
              )
            )}
        </div>
      ) : (
        <div>{t("No details")}</div>
      )}
    </div>
  );
};

export default Sizes;
